import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { useCallback } from 'react';
import { minimalLegalEntityInputsConfig } from './minimalBorrowerForm.inputs';

// Visible field names for legal entity form
type MinimalLegalEntityVisibleFields =
  | LegalEntityFormFieldNames.CompanyName
  | PersonalInformationFieldNames.Email;

export const MinimalLegalEntityLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.Borrower, NsKey.ActorForm]);

  const renderField = useCallback((fieldName: MinimalLegalEntityVisibleFields) => {
    return (
      <InputFactory<MinimalLegalEntityVisibleFields>
        config={minimalLegalEntityInputsConfig}
        fieldName={fieldName}
      />
    );
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-gray-500 mb-2">
        {t('BORROWER.MINIMAL_FORM.DESCRIPTION_LEGAL')}
      </p>
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-6">
          {renderField(LegalEntityFormFieldNames.CompanyName)}
        </div>
        <div className="col-span-6">
          {renderField(PersonalInformationFieldNames.Email)}
        </div>
      </div>
    </div>
  );
};
